export default __webpack_public_path__ + "static/media/marathi_agri_m.be1362ed.wav";